export const SET_USERDATA = "SET_USERDATA";

export interface SetUserData {
  type: typeof SET_USERDATA;
  userData: object | any;
}

export type UserActionsTypes = SetUserData;
